import { OutputBlockData, OutputData } from '@editorjs/editorjs';

import { parseHeader } from './header';
import { parseImage } from './image';
import { parseConsecutiveLists } from './list';
import { parseParagraph } from './paragraph';

export const parseHtmlStringToOutputData = (htmlString: string): OutputData => {
  const elements = getElements(htmlString);
  const blocks: OutputBlockData[] = [];

  let i = 0;
  while (i < elements.length) {
    const element = elements[i];

    if (isConsecutive(elements, i)) {
      const consecutiveLists: Element[] = [];

      while (i < elements.length) {
        const currentTag = elements[i].tagName.toLowerCase();
        if (currentTag === 'ul' || currentTag === 'ol') {
          consecutiveLists.push(elements[i]);
          i++;
        } else break;
      }

      const listBlock = parseConsecutiveLists(consecutiveLists);
      if (listBlock) blocks.push(listBlock);
    } else {
      const parsedBlocks = parseElement(element);
      blocks.push(...parsedBlocks);
      i++;
    }
  }

  return {
    version: '2.30.2',
    time: Date.now(),
    blocks,
  };
};

const getElements = (htmlString: string): Element[] => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return Array.from(doc.body.children);
};

const isConsecutive = (elements: Element[], i: number): boolean => {
  const tagName = elements[i].tagName.toLowerCase();
  return tagName === 'ul' || tagName === 'ol';
};

const parseElement = (element: Element): OutputBlockData[] => {
  const tagName = element.tagName.toLowerCase();

  if (tagName === 'p') {
    return parseParagraph(element);
  }

  if (tagName === 'img') {
    return parseImage(element as HTMLImageElement);
  }

  if (['h4', 'h5', 'h6'].includes(tagName)) {
    return parseHeader(element);
  }

  return [];
};
